import { render, staticRenderFns } from "./TextareaWithTag.vue?vue&type=template&id=00fb3583&"
import script from "./TextareaWithTag.vue?vue&type=script&lang=js&"
export * from "./TextareaWithTag.vue?vue&type=script&lang=js&"
import style0 from "./TextareaWithTag.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VForm,VIcon,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00fb3583')) {
      api.createRecord('00fb3583', component.options)
    } else {
      api.reload('00fb3583', component.options)
    }
    module.hot.accept("./TextareaWithTag.vue?vue&type=template&id=00fb3583&", function () {
      api.rerender('00fb3583', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Message/components/TextareaWithTag.vue"
export default component.exports